import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { ResellerTokenResponse } from '@utils/types/resellers/reseller-token.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export const useGetResellerTokens = (customerId: string) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchResellerTokens = async () => {
    if (!customerId) throw new Error('customerId is required');
    const { resellerTokensByCustomerId } = GET_URL_NEW();
    const url = resellerTokensByCustomerId(customerId, {
      offset,
      limit,
      q,
      sort,
      direction
    });
    const { data } = await Axios.get<ResellerTokenResponse>(url);
    return data;
  };

  return useQuery<ResellerTokenResponse, AxiosError<BaseError>>(
    ['resellerTokens', customerId, offset, limit, q, sort, direction],
    fetchResellerTokens,
    { keepPreviousData: true, enabled: !!customerId }
  );
};
